<div class="lab-pass">
  <app-breadcrumb [items]="repository.breadcrumbs"></app-breadcrumb>

  <div class="section bg-blue-light">
    <div class="section-content">
      <app-lab-pass-banner></app-lab-pass-banner>
    </div>
  </div>

  <div class="section mt-80">
    <div class="section-content">
      <app-advantage></app-advantage>
    </div>

    <div class="section-content">
      <app-how-work></app-how-work>
    </div>
  </div>

  <div class="section">
    <div class="section-content">
      <app-where-use [appsContainer]="appsContainer"></app-where-use>
    </div>
  </div>

  <div class="section bg-blue-light">
    <div class="section-content">
      <app-questions></app-questions>
    </div>
  </div>

  <div class="section lab-pass-questions">
    <div class="lab-pass-container">
      <div class="typography typography-align-center typography-huge mb-40">
        Остались вопросы?
      </div>
      <app-form-questions></app-form-questions>
    </div>
  </div>

  <div class="section bg-blue-light" #appsContainer>
    <div class="section-content">
      <app-download-app></app-download-app>
    </div>
  </div>
</div>
